module.exports = __webpack_public_path__ + "img/university-df3.89c8a10b.png";